import {createStore } from "vuex";

import auth from "./modules/auth";
import core from "./modules/core";
import shoppingCart from "./modules/shoppingCart";

export default createStore({
    modules:{
        auth,
        core,
        shoppingCart
    }

})